$(document).ready(function() {

  $('#article-body').fitVids();

  /*
    Rebuild article headers for mobile
  */
  var rebuildArticleHeader = function(){
    var $postTitle = $('.entry-header h1').detach();
    var $postExcerpt = $('.entry-header .excerpt').detach();
    var $postSharing = $('.entry-header nav').detach();
    var $postImage = $('.entry-header .image picture').detach();
    if( $(window).width() < 768 && $('#m-variation h1').length < 1 ){
      $('#m-variation [data-image-container]')
        .append($postTitle)
        .append($postImage);
      $('#m-variation [data-content-container]')
        .append($postExcerpt)
        .append($postSharing);
    }else if( $('#d-variation h1').length < 1 ){
      $('#d-variation [data-image-container]')
        .append($postImage);
      $('#d-variation [data-content-container]')
        .append($postTitle)
        .append($postExcerpt)
        .append($postSharing);
    }
    if( $(window).width() < 768 ){
      $('#m-variation [data-image-container]').css( 'height', $(window).outerHeight() - $header.outerHeight() + 2 ); // the +2 fixes a white line at the bottom
    }
  }
  rebuildArticleHeader();
  $(window).resize(function(){
    rebuildArticleHeader();
  });

  if ($('#comments-list .comments').length) {
    let searchParams = new URLSearchParams(window.location.search)
    if(searchParams.has('page')) {
      $('html, body').animate({ scrollTop: $('#comments').offset().top - 80}, 800);
    }
  }

  /*
  Simple Sharing
  */
  $('.share-btn').on('click', function(e){
    if( !$(this).hasClass('email') ){
      e.preventDefault();
      window.open($(this).attr('href'), 'shareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }
});

});